const state = {
  product: {},
  addToBagOpen: false,
};

const mutations = {
  setProduct(state, value) {
    state.product = value;
  },
  setAddToBagOpen(state, value) {
    state.addToBagOpen = value;
  },
};

const getters = {};

const actions = {
  setProduct({ commit }, product) {
    commit("setProduct", product);
  },
  openAddToBag({ commit, dispatch }, product) {
    dispatch("closeAddToBag");
    setTimeout(() => {
      commit("setProduct", product);
      commit("setAddToBagOpen", true);
    }, 100);
  },
  closeAddToBag({ commit }) {
    commit("setAddToBagOpen", false);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
